import { PropsWithChildren } from 'react'

import { Card, Stack, useTheme } from '@mui/material'

import {
  DATEPICKER_SELECTORS,
  DAY_RANGE_END_BG_SELECTOR,
  DAY_RANGE_START_BG_SELECTOR,
  SELECTED_DAYS_BUTTONS_SELECTOR
} from './constants'

export const DateRangeCalendarContainer = ({ children }: PropsWithChildren) => {
  const theme = useTheme()

  return (
    <Card
      elevation={7}
      sx={{
        width: '100%',
        [DATEPICKER_SELECTORS.dayNames]: {
          display: 'none'
        },
        [DATEPICKER_SELECTORS.week]: {
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 40px)',
          gap: '2px'
        },
        '.react-datepicker__day': {
          width: '40px',
          height: '40px',
          margin: 0
        },
        [DATEPICKER_SELECTORS.dayOutsideMonthButton]: {
          color: theme.palette.grey[600]
        },
        [SELECTED_DAYS_BUTTONS_SELECTOR]: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText
        },
        [`${DATEPICKER_SELECTORS.dayInSelectingRange}, ${DATEPICKER_SELECTORS.dayInRange}`]: {
          backgroundColor: theme.palette.dateRangePicker.rangeBackground,
          color: theme.palette.primary.contrastText,

          '&:first-child': {
            borderTopLeftRadius: theme.palette.dateRangePicker.borderRadius,
            borderBottomLeftRadius: theme.palette.dateRangePicker.borderRadius
          },
          '&:last-child': {
            borderTopRightRadius: theme.palette.dateRangePicker.borderRadius,
            borderBottomRightRadius: theme.palette.dateRangePicker.borderRadius
          }
        },
        [DATEPICKER_SELECTORS.month]: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '2px'
        },
        [DAY_RANGE_START_BG_SELECTOR]: {
          borderTopLeftRadius: theme.palette.dateRangePicker.borderRadius,
          borderBottomLeftRadius: theme.palette.dateRangePicker.borderRadius
        },
        [DAY_RANGE_END_BG_SELECTOR]: {
          borderTopRightRadius: theme.palette.dateRangePicker.borderRadius,
          borderBottomRightRadius: theme.palette.dateRangePicker.borderRadius
        },
        [DATEPICKER_SELECTORS.ariaLiveMonthValue]: {
          display: 'none'
        }
      }}
    >
      <Stack direction="row" justifyContent="center" alignItems="flex-start" gap={3} margin={2}>
        {children}
      </Stack>
    </Card>
  )
}
